<template>
<div class="account-card">
<!--先不考虑赠金活动-->
  <div class="card-up">
    <div class="up-top">
      <div class="up-top-left">
        <span
          class="login-num login-or-alias"
        >{{accountInfo.alias || accountInfo.login}}</span>
        <div
          class="real-tag tag theme-color"
          :style="themeOpacty"
        >{{getAccountType(accountInfo,this)}}</div>
        <div class="mt4-tag tag">MT4</div>
      </div>
      <div class="up-top-right" v-if="!(accountInfo.businessType == 5 && accountInfo.accountStatus == 1)">
        <account-operate
          @transferHandle="transferHandle"
          @leverHandle="leverHandle"
          @passwordHandle="passwordHandle"
          @accountTypeSetHandle="accountTypeSetHandle"
          :is-demo="isDemo"
          :account-info="accountInfo"
        ></account-operate>
      </div>
    </div>
    <div
      class="bt-list">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-button
            :disabled="isDemo"
            class="neededit-btn"
            size="large"
            @click="depositHandle"
          >{{$t('User.in')}}</el-button>
        </el-col>
        <el-col :span="8">
          <el-button
            :disabled="isDemo"
            class="neededit-btn"
            size="large"
            @click="withdrawHandle"
          >{{$t('User.out')}}</el-button>
        </el-col>
        <el-col :span="8" v-if="!(accountInfo.businessType == 5 && accountInfo.accountStatus == 1)">
          <el-button
            class="neededit-btn"
            size="large"
            @click="tradeHandle"
          >{{$t('trade')}}</el-button>
        </el-col>
        <el-col :span="8" v-else>
          <el-button
            class="neededit-btn reactivate-btn"
            size="large"
            @click="reactivateHandle"
          >{{$t('reactivate')}}</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
  <div class="card-bot">
    <div class="line-box">
      <div class="line-box-left">
        {{$t('transaction_account')}}
      </div>
      <div class="line-el"></div>
      <div class="line-box-right">
        {{accountInfo.login}}
        <i
          class="iconfont icon-copy1 pointer"
          @click="copyHandle(accountInfo.login)"
        ></i>
      </div>
    </div>
    <div class="line-box">
      <div class="line-box-left">
        {{$t('server')}}
      </div>
      <div class="line-el"></div>
      <div class="line-box-right">
        {{accountInfo.serverName}}
        <i
          class="iconfont icon-copy1 pointer"
          @click="copyHandle(accountInfo.serverName)"
        ></i>
      </div>
    </div>
    <div class="line-box">
      <div class="line-box-left">
        {{$t('Group')}}
      </div>
      <div class="line-el"></div>
      <div class="line-box-right">
        {{accountInfo.accType}}
      </div>
    </div>
    <div class="line-box">
      <div class="line-box-left">
        {{$t('User.forexLeverage')}}
        
        <el-tooltip class="item maxwidthtooltips" popper-class="maxwidthtooltips" effect="dark" :content="$t('User.accountCardTips1')" placement="top">
          <i class="el-icon-info icon-el iconcolor"></i>
        </el-tooltip>
        

      </div>
      <div class="line-el"></div>
      <div class="line-box-right">1:{{accountInfo.leverage}}</div>
    </div>
    <div class="line-box">
      <div class="line-box-left">
        {{$t('User.preciousMetalLeverage')}}
        <el-tooltip class="item maxwidthtooltips" popper-class="maxwidthtooltips" effect="dark" :content="$t('User.accountCardTips2')" placement="top">
          <i class="el-icon-info icon-el iconcolor"></i>
        </el-tooltip>
      </div>
      <div class="line-el"></div>
      <div class="line-box-right" v-if="accountInfo.businessType != 5">1:{{accountInfo.preciousMetalLeverage || accountInfo.preciousMetalLeverage == 0?accountInfo.preciousMetalLeverage:""}}</div>
      <div class="line-box-right" v-else>
        1:100
      </div>
    </div>
    <div class="line-box">
      <div class="line-box-left">
        {{$t('User.liquidationRatio')}}
        <el-tooltip class="item maxwidthtooltips" popper-class="maxwidthtooltips" effect="dark" :content="$t('User.accountCardTips3')" placement="top">
          <i class="el-icon-info icon-el iconcolor"></i>
        </el-tooltip>
      </div>
      <div class="line-el"></div>
      <div class="line-box-right" v-if="accountInfo.businessType != 5">{{accountInfo.forceClosedRate || accountInfo.forceClosedRate == 0?accountInfo.forceClosedRate+'%': ""}}</div>
      <div class="line-box-right" v-else>
        100%
      </div>
    </div>
    <div class="line-box">
      <div class="line-box-left">
        {{$t('User.collateralMarginRatio')}}
        <el-tooltip class="item maxwidthtooltips" popper-class="maxwidthtooltips" effect="dark" :content="$t('User.accountCardTips4')" placement="top">
          <i class="el-icon-info icon-el iconcolor"></i>
        </el-tooltip>
      </div>

      
      <div class="line-el"></div>
      <div class="line-box-right" v-if="accountInfo.businessType != 5">{{accountInfo.lockedMarginRate||accountInfo.lockedMarginRate == 0?accountInfo.lockedMarginRate+'%': ""}}</div>
      <div class="line-box-right" v-else>
        50%
      </div>
    </div>
    <div class="line-box">
      <div class="line-box-left">
        {{$t('equity')}}
      </div>
      <div class="line-el"></div>
      <div class="line-box-right">{{accountInfo.equity}}{{currency}}</div>
    </div>
    <div class="line-box">
      <div class="line-box-left">
        {{$t('balance')}}
      </div>
      <div class="line-el"></div>
      <div class="line-box-right">{{accountInfo.balance}}{{currency}}</div>
    </div>
    <div class="line-box">
      <div class="line-box-left">
        {{$t('credit_amount')}}
      </div>
      <div class="line-el"></div>
<!--      需要对下信用额是不是也是净值的字段 todo-->
      <div class="line-box-right">{{accountInfo.credit}}{{currency}}</div>
    </div>

    <div class="line-box">
      <div class="line-box-left">
        {{$t('state')}}
      </div>
      <div class="line-el"></div>
      <div class="line-box-right">
        <mt4-status
          :account-info="accountInfo"
        ></mt4-status>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import copy from 'copy-to-clipboard';
import  accountOperate from "@/components/dashboard/accountOperate";
import { jumpDetailsPage,getAccountType } from '@/utils/common'
import { mapGetters } from 'vuex'
import mt4Status from "@/components/public/mt4Status";
import { colorRgba } from '@/utils/index.js';
export default {
  name: "accountCard",
  components:{
    mt4Status,
    accountOperate,
  },
  props: {
    accountInfo: {
      type: Object,
      default(){
        return {

        }
      }
    },
    isDemo: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters(['themeColor','userInfo']),
    themeOpacty(){
      return {
        background: colorRgba(this.themeColor,0.1),
      }
    },
    accTypeText(){
      if(this.accountInfo.businessType == 5){
        return this.$t('Demo_account');
      }else {
        return this.$t('live');
      }
    },
    currency(){
      return ' ' + this.accountInfo.currency
    }
  },
  methods: {
    getAccountType,
    copyHandle(info){
      copy(info);
      this.$message({
        type: 'success',
        message: this.$t('User.copySuccess'),
      })
    },
    detailHandle(){
      // 详情页面
      if(this.isDemo) return;
      localStorage.setItem('goBackRouterName','dashboard');
      jumpDetailsPage({
        vm: this,
        userInfo: this.userInfo,
        signalInfo: this.accountInfo,
      })
    },
    transferHandle() {
      this.$store.commit('setDepositAccount',this.accountInfo.login);
      this.$router.push({name: 'transfers'});
    },
    leverHandle(){
      this.$emit('lever-setting',this.accountInfo);
    },
    passwordHandle(){
      this.$emit('password-setting',this.accountInfo);
    },
    accountTypeSetHandle(){
      this.$emit('type-set',this.accountInfo);
    },
    // 入金
    depositHandle(){
      this.$store.commit('setDepositAccount',this.accountInfo.login);
      this.$router.push({name: 'depositFunds'});
    },
    // 出金
    withdrawHandle(){
      this.$store.commit('setDepositAccount',this.accountInfo.login);
      this.$router.push({name: 'withdraw'});
    },
    // 交易
    tradeHandle(){
      this.$emit('trande-click',this.accountInfo);
    },
    // 重新激活
    reactivateHandle(){
      this.$emit('reactivate-click',this.accountInfo);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variable";
.account-card {
  background-color: #ffffff;
  border-radius: 5px;
  .card-up {
    padding: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #DCDFE6;
    .up-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;

      .up-top-left {
        display: flex;
        justify-content: flex-start;
        align-items: center;

      }
    }
  }
  .card-bot {
    padding: 16px 20px;
    .line-box {
      margin-bottom: 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      .line-box-left {
        color: #A29FAE;
      }
      .line-box-right {
        color: #5E5873;
        font-size: 14px;
      }
      .line-el {
        flex: 1;
        height: 0;
        border-bottom: 1px dashed #D8D6DE;
        margin: 0 10px;
      }
    }
  }
  .up-top-right {
    .el-icon-setting {
      font-size: 16px;
    }
  }
  .neededit-btn {
    width: 100%;
  }
  .reactivate-btn {
    background-color: #FE5924 !important;
    color: #ffffff !important;
    border-color: #FE5924 !important;
    &:hover {
      background-color: #FE5924 !important;
      color: #ffffff !important;
      border-color: #FE5924 !important;
    }
    &:focus {
      background-color: #FE5924 !important;
      color: #ffffff !important;
      border-color: #FE5924 !important;
    }
  }

}
@media (min-width: 1400px) and (max-width: 1600px) {
  .login-or-alias {
    max-width: 80px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
<style lang="scss">
.account-card {
  margin-bottom: 10px;

}
</style>
